import { theme } from '@config/theme';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Card } from '@mui/material';
import CardActionArea from '@mui/material/CardActionArea/CardActionArea';
import { useTranslation } from 'react-i18next';

const addCropCardStyles = {
	cursor: 'pointer',
	minHeight: '170px',
	borderRadius: 2,
	boxShadow: theme.boxShadows.primary,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	position: 'relative',
	overflow: 'visible',
};

export function CropAdderCard() {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	const handleAdd = () => {
		localStorage.removeItem('farmId');
		navigateWithLanguage('/farmer/my-farm/create');
	};

	return (
		<CardActionArea onClick={handleAdd}>
			<Card onClick={handleAdd} elevation={0} sx={addCropCardStyles}>
				<div className="flex items-center justify-center flex-col gap-[10px]">
					<AddCircleOutlineOutlinedIcon
						sx={{
							width: '40px',
							height: '40px',
						}}
						color="primary"
					/>
					<p className="text-dark-gray font-roboto text-xl font-bold leading-140">
						{t('myFarm.addNewCrop')}
					</p>
				</div>
			</Card>
		</CardActionArea>
	);
}
